'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    'zh-cn': {
        datePlaceholder: '请选择日期',
        monthPlaceholder: '请选择月份',
        yearPlaceholder: '请选择年份',
        rangeStartPlaceholder: '起始日期',
        rangeEndPlaceholder: '结束日期',
        now: '此刻',
        selectTime: '选择时间',
        selectDate: '选择日期',
        ok: '确定',
        clear: '清除'
    },
    'en-us': {
        datePlaceholder: 'Select date',
        monthPlaceholder: 'Select month',
        yearPlaceholder: 'Select year',
        rangeStartPlaceholder: 'Start date',
        rangeEndPlaceholder: 'End date',
        now: 'Now',
        selectTime: 'Select time',
        selectDate: 'Select date',
        ok: 'OK',
        clear: 'Clear'
    },
    'zh-tw': {
        datePlaceholder: '請選擇日期',
        monthPlaceholder: '請選擇月份',
        yearPlaceholder: '請選擇年份',
        rangeStartPlaceholder: '起始日期',
        rangeEndPlaceholder: '結束日期',
        now: '此刻',
        selectTime: '選擇時間',
        selectDate: '選擇日期',
        ok: '確定',
        clear: '清除'
    }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-week-picker@0.0.4@@alicd/crui-week-picker/lib/locale.js
// module id = 727
// module chunks = 0